import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import NormalGameManager from "../../manager/NormalGameManager";
import loveStoryRecordPrefab from "./loveStoryRecordPrefab";

const {ccclass, property} = cc._decorator;
/**
 * 添加提现 机会 次数
 */
@ccclass
export default class BillRecordPrefab extends cc.Component {

    @property({type:cc.Prefab,displayName:"记录Item预制体"})
    recordItemPrefab : cc.Prefab = null;
    @property({type:cc.Node,displayName:"内容节点"})
    contentNode : cc.Node = null;
    @property({type:cc.Label,displayName:"总共收入"})
    lbTotal : cc.Label = null;

    @property({type:cc.Node,displayName:"中心动画节点"})
    centerNode:cc.Node = null;

    onLoad () {
        this.centerNode.scale = 0;
        cc.tween(this.centerNode).to(.5,{scale:1},{easing:cc.easing.backOut}).start();
    }

    start () {
        let totalCoin = NormalGameManager._instance.loveStroyManager.getAllCoins();
        this.lbTotal.string = `${data_control.getNumberFormat(totalCoin)}`;
        this.refreshData();
    }

    /**
     * 刷新数据
     */
    refreshData(){
        let allRecords = NormalGameManager._instance.loveStroyManager.getDataRecord();
        for ( let record of allRecords ) {
            let recordItemNode = cc.instantiate( this.recordItemPrefab );
            recordItemNode.getComponent( loveStoryRecordPrefab ).bindData( record.peopleId , record , 510 ).then( );
            this.contentNode.addChild( recordItemNode );
        }
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this._close();
    }

    private _close(){
        this.node.removeFromParent();
        this.node.destroy();
    }
}
